import { NotificationMessages } from '../types';

export const notificationCA: NotificationMessages = {
    'app.notification.title': 'Centre de notificacions',
    "app.notification.generate_file": "Estem generant el teu fitxer. Quan estigui llest, rebràs una notificació per descarregar-lo.",
    'app.notification.download_program': 'Descarregar els detalls del programa',
};
